import Content from './content';

/**
 * Custom bootstrap gallery element.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class Gallery extends Content {
  /**
   * Container for displaying the big, currently selected image.
   *
   * @type {HTMLElement}
   * @private
   */
  private imageContainer: HTMLElement;

  /**
   * Contains all big image.
   *
   * @type {NodeListOf<HTMLElement>}
   * @private
   */
  private images: NodeListOf<HTMLElement>;

  /**
   * Container of the bootstrap carousel, used as a image browser.
   *
   * @type {HTMLElement}
   * @private
   */
  private carousel: HTMLElement;

  /**
   * Bootstrap carousel items used as thumbnails for selecting a big image.
   *
   * @type {NodeListOf<HTMLElement>}
   * @private
   */
  private thumbnails: NodeListOf<HTMLElement>;


  constructor(container: HTMLElement) {
    super(container);
    this.imageContainer = this.container.querySelector('.image-container');
    this.images = this.imageContainer.querySelectorAll('.image');
    this.carousel = this.container.querySelector('.carousel');
    this.thumbnails = this.carousel.querySelectorAll('.thumbnail');

    this.initializeThumbnailNavigation();

  }


  /**
   * Initializes the thumbnail navigation.
   *
   * @returns {void}
   */
  private initializeThumbnailNavigation(): void {
    this.thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {
        const activeImage = this.imageContainer.querySelector('.active');
        const nextImage = this.imageContainer.querySelector('[data-id="' + thumbnail.dataset.id + '"]');
        if (activeImage === nextImage) {
          return;
        }

        // Transition away old image, and show new one
        activeImage.classList.add('hiding');

        setTimeout(() => {
          nextImage.classList.add('showing');
        }, 500);

        setTimeout(() => {
          activeImage.classList.remove('hiding', 'active');
          nextImage.classList.remove('showing');
          nextImage.classList.add('active');
        }, 600);
      });
    });
  }
}
